import { createBackgroundLoaderContext } from "contexts";
import { HiredTeacherPlacements } from "models";

export const HiredTeacherPlacementContext = createBackgroundLoaderContext<HiredTeacherPlacements>();
